import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** lo que se tipeó en el buscador: precarga nombre y apellido */
  initialName?: string;
  onCreated: (client: any) => void;
}

/** Alta mínima de cliente desde el turno: nombre, apellido, teléfono y email */
const ClienteNuevoDialog: React.FC<Props> = ({ open, onOpenChange, initialName = '', onCreated }) => {
  const [form, setForm] = useState({ firstName: '', lastName: '', phone: '', email: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    const parts = initialName.trim().split(/\s+/).filter(Boolean);
    setForm({ firstName: parts[0] || '', lastName: parts.slice(1).join(' '), phone: '', email: '' });
  }, [open, initialName]);

  const crear = async () => {
    const firstName = form.firstName.trim();
    if (!firstName) {
      toast.error('El nombre es requerido');
      return;
    }
    setSaving(true);
    try {
      const res = await axios.post('/api/clients', {
        type: 'individual',
        firstName,
        lastName: form.lastName.trim() || null,
        phone: form.phone.trim() || null,
        email: form.email.trim() || null
      });
      const created = res.data?.client || res.data;
      onCreated(created);
      onOpenChange(false);
      toast.success('Cliente creado');
    } catch (error: any) {
      toast.error(error?.response?.data?.error || 'No se pudo crear el cliente');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Cliente nuevo</DialogTitle>
        </DialogHeader>
        <form
          className="space-y-4"
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            crear();
          }}
        >
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            <div className="space-y-1.5">
              <Label htmlFor="cn-firstName">Nombre <span className="text-destructive">*</span></Label>
              <Input id="cn-firstName" autoFocus value={form.firstName} onChange={(e) => setForm((f) => ({ ...f, firstName: e.target.value }))} placeholder="Juan" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="cn-lastName">Apellido</Label>
              <Input id="cn-lastName" value={form.lastName} onChange={(e) => setForm((f) => ({ ...f, lastName: e.target.value }))} placeholder="Pérez" />
            </div>
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="cn-phone">Teléfono</Label>
            <Input id="cn-phone" inputMode="tel" value={form.phone} onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))} placeholder="3416858698" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="cn-email">Email</Label>
            <Input id="cn-email" type="email" value={form.email} onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} placeholder="cliente@email.com" />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={saving}>Cancelar</Button>
            <Button type="submit" disabled={saving}>{saving ? 'Creando…' : 'Crear cliente'}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ClienteNuevoDialog;
